<template>
  <div class="animated fadeIn">
      <loader :show="enviando"/>
    <b-card title="Informativo de trámites">
        <div>
          <b-col sm="5">
            <h4 id="traffic" class="card-title mb-0"></h4>
          </b-col>
        </div>
        <b-row align-h="around">
          <b-col sm="12" md="6" lg="4" v-for="(element,index) in areas" :key="index">
            <b-card
              tag="article"
              style="max-width: 20rem;"
              class="mb-2"
            >
            <b-card-img style="padding-bottom: 10px;" src="https://picsum.photos/600/300/?image=25" :top="true" width="100%"/>

            <b-button-group size="sm" class="pull-right" >
                        
                  <b-button 
                      :variant="element.visible ? 'outline-success' : 'outline-secondary'"
                      v-b-tooltip.hover :title="element.visible ? 'Visible en la página' : 'No visible en la página'"
                      @click="cambiaVisible(element._id,index)">
                      <i :class="element.visible ? 'fa fa-lg fa-globe': 'fa fa-lg fa-globe'"></i>
                  </b-button>

                  <b-button 
                      v-if="puedeModificarArea"
                      variant="outline-secondary"
                      v-b-tooltip.hover title="Modificar área"
                      @click="modificaModal(index)">
                      <i class="fa fa-pencil fa-lg"></i>
                  </b-button>

              </b-button-group>

              <div>
                <h4>{{element.area}}</h4>
              </div>
              <div v-html="element.descripcion"></div>

              <div >
                <b-button variant="primary" size="sm" @click="agregarArea()">Trámites</b-button>
              </div>

            </b-card>
          </b-col>
        </b-row>
        <div>&nbsp;</div>
        <div>
          <b-row v-if="puedeAgregarArea" align-h="end">
            <b-col cols="2">
              <b-button variant="primary" size="sm" @click="agregarArea()">Agregar área</b-button>
            </b-col>
          </b-row>
        </div>
    </b-card>

    <!-- ===================== MODAL PARA MODIFICAR AREA ======================= -->
    <b-modal 
        v-model="modal.mostrar"
        title="Modificar área"
        :ok-disabled="enviando || !modal.area"
        :cancel-disabled="enviando"
        @ok="modificaArea()"
        ok-title="Guardar"
        size="lg"
        cancel-title="Cancelar">
        
        <label for="docName"><strong>Nombre:</strong></label>
        <b-form-input 
            v-model="modal.area"
            type="text"
            :state="modal.area"
            :disabled="enviando"
            aria-describedby="inputLiveFeedback"
            placeholder="Ingrese un nombre">
        </b-form-input>

        <label for="docCurri"><strong>Descripción:</strong></label>
        <vue-ckeditor 
            v-model="modal.descripcion" 
            :config="editorConfig" 
        />

        <label v-if="enviando" class="pull-right"><i>Guardando datos...</i></label>
    </b-modal>



  </div>
</template>

<script>

import axios from 'axios'
import Loader from '../../Loader'
import { mapGetters } from "vuex";
import VueCkeditor from 'vue-ckeditor2'

export default {
  name: 'TramitesInfo',
  components: {
    Loader,
    VueCkeditor
  },
  computed:{
    ...mapGetters([
        "httpURL",
        "sessionToken",
        "permisos",
        "role",
        "tableProps"
      ]),
      puedeAgregarArea(){
        if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 152) >= 0 )
          return true;
        else
          return false;
      },
      puedeModificarArea(){
        if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 153) >= 0 )
          return true;
        else
          return false;
      },
  },
  data: function () {
    return {
        enviando: false,
        areas: [],
        modal:{
          mostrar: false,
          id: null,
          area: '',
          descripcion: ''
        },
        editorConfig: {
          toolbar: [
            ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript'],
            ['NumberedList','BulletedList','JustifyLeft','JustifyCenter','JustifyRight','JustifyBlock','TextColor','BGColor'],
            ['Link','Table','SpecialChar','Styles','Format','Font','FontSize'],
            ['Cut','Copy','Paste','PasteText','PasteFromWord','Undo','Redo']
          ],
          height: 300
        }
    }
  },
  created(){
        this.enviando = true;
        axios.get(this.httpURL+'/tramites/informativo/areas',{headers:{token:this.sessionToken}})
            .then(res => {
                //console.log(res.data);
                this.areas = res.data.areas;
                // this.quincenasTabla.data = res.data.quincenas;
                this.enviando = false;
            })
            .catch(error => {
                this.enviando = false;
                if(error.response){
                    this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: error.response.data.mensaje });
                }else if( error.request){
                    this.$notify({ group: 'foo', type:"error", duration:1500, speed: 1000,
                        text: 'No se pudo establecer una conexión al servidor.' });
                }
            });
  },
  methods: {
    agregarArea(){
        this.enviando = true;
        axios.post(this.httpURL+'/tramites/informativo/areas',{},{headers:{token:this.sessionToken}})
            .then(res => {
                // console.log(res.data);
                this.tramites.push(res.data.area);
                this.enviando = false;
                this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                        text: res.data.mensaje });
            })
            .catch(error => {
                this.enviando = false;
                if(error.response){
                    this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: error.response.data.mensaje });
                }else if( error.request){
                    this.$notify({ group: 'foo', type:"error", duration:1500, speed: 1000,
                        text: 'No se pudo establecer una conexión al servidor.' });
                }
            });
    },
    cambiaVisible(id,index){
      axios.put(this.httpURL+'/tramites/informativo/areas/visible/'+id,{},{headers:{token:this.sessionToken}})
            .then(res => {
                // console.log(res);
                this.enviando = false;
                if(res.status === 200 ){
                  this.areas[index].visible = res.data.visible;
                  this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                          text: res.data.mensaje });
                }else{
                  this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: res.data.mensaje });
                }
            })
            .catch(error => {
                this.enviando = false;
                if(error.response){
                    this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: error.response.data.mensaje });
                }else if( error.request){
                    this.$notify({ group: 'foo', type:"error", duration:1500, speed: 1000,
                        text: 'No se pudo establecer una conexión al servidor.' });
                }
            });
    },
    modificaModal(index){
      let tmp = this.$_.clone(this.areas[index]);
      this.modal.id = tmp._id; 
      this.modal.area = tmp.area; 
      this.modal.descripcion = tmp.descripcion; 
      this.modal.mostrar = true;
    },
    modificaArea(){
      axios.put(this.httpURL+'/tramites/informativo/areas/datos/'+this.modal.id,
            {area:this.modal.area,descripcion:this.modal.descripcion},
            {headers:{token:this.sessionToken}})
            .then(res => {
                // console.log(res);
                this.enviando = false;
                let index = this.areas.findIndex(x=> x._id == this.modal.id);
                this.areas[index].area = this.modal.area;
                this.areas[index].descripcion = this.modal.descripcion;
                this.modal.mostrar = false;
                this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                        text: res.data.mensaje });
            })
            .catch(error => {
                this.enviando = false;
                if(error.response){
                    this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: error.response.data.mensaje });
                }else if( error.request){
                    this.$notify({ group: 'foo', type:"error", duration:1500, speed: 1000,
                        text: 'No se pudo establecer una conexión al servidor.' });
                }
            });
    }
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>
